
import {
  IonContent,
  IonGrid,
  IonRow,
  IonCol,
  IonInput,
  IonButton,
  IonAlert,
  modalController,
} from "@ionic/vue";
import { defineComponent, getCurrentInstance, ref } from "vue";
import { LoginUtility } from "../LoginUtility/LoginUtility";
//import environments from "@/../public/environments.json"; // Import environments.json from the public directory
import { useRouter } from "vue-router";
import { useApplicationStore } from "@/stores/ApplicationStore";

//import { useStore } from 'vuex'
// import { key } from '../../store'

export default defineComponent({
  name: "LoginPage",
  components: {
    IonContent,
    IonGrid,
    IonRow,
    IonCol,
    IonInput,
    IonButton,
    IonAlert,
  },
  /*setup() {
    const Background = function background () {
    return require("../../assets/background.jpg")
  }
    const router = useRouter();
    const instance: any = getCurrentInstance();

    // const BACKGROUND_IMAGE =
    //   instance.appContext.config.globalProperties.$BACKGROUND_IMAGE;
      const BACKGROUND_IMAGE = "../../assets/background.jpg"
    const LOGO_IMAGE = instance.appContext.config.globalProperties.$LOGO_IMAGE;
    const backgroundStyle = ref({
      background: `url(${Background}) no-repeat center center fixed`,
      // background: `url(@/assets/backgorund.jpg) no-repeat center center fixed`,
      height: "100%",
      "-webkit-background-size": "cover",
      "-moz-background-size": "cover",
      "-o-background-size": "cover",
      "background-size": "cover",
      color: "#ffffff",
    });
    return { router, backgroundStyle, LOGO_IMAGE };
  },*/

  setup() {
    const router = useRouter();

    const appStore = useApplicationStore();

    const backgroundStyle = ref({
      background: `url(${appStore.$BACKGROUND_IMAGE}) no-repeat center center fixed`,
      height: "100%",
      "-webkit-background-size": "cover",
      "-moz-background-size": "cover",
      "-o-background-size": "cover",
      "background-size": "cover",
      color: "#ffffff",
    });

    return { router, appStore, backgroundStyle};
  },

  data() {
    return {
      model: {
        username: "",
        password: "",
      },
      AlertMessage: "",
      isOpenRef: false,
    };
  },
  methods: {
    Login_click() {
      console.log(this.model.username);
      if (!this.model.username) {
        //metti un utente
        this.ShowAlert(true, "Inserire un utente");

        return;
      }

      if (!this.model.password) {
        //metti una pass
        this.ShowAlert(true, "Inserire una password");

        return;
      }

      //eseguo login
      const loginUtility = new LoginUtility();
      const store = useApplicationStore();
      loginUtility
        .LogIn(
          this.model.username,
          this.model.password,
          this.$API_AUTH_URL,
          this.$API_DBOX_URL,
          this.$API_KEY
        )
        .finally(() => {
          if (store.$APP_READY) {
            this.router.push("/etichetteApp/tab2");
            //chiudo il modale

            modalController.dismiss();
          } else {
            //mando messaggio errore server
            this.ShowAlert(
              true,
              "Errore di login controllare username e password"
            );
          }

          // Expected output: 123
        }); //.catch(error =>  console.log(error));
    },
    ShowAlert(state: boolean, message?: string) {
      this.AlertMessage = message ? message : "";
      this.isOpenRef = state;
    },
  },
});
